// src/PrivacyPolicy.js

import React from 'react';
import '../styles/PrivacyPolicy.css'; // Import the CSS file for styling

const PrivacyPolicy = () => {
    return (
        <div className="privacy-policy-container">
                <h1>Privacy Policy</h1>
            <div className="content">
                <p>
                    Your privacy is important to us. This Privacy Policy explains how we collect, use, 
                    and disclose your information when you visit our website or use our services.
                </p>

                <h2>Information We Collect</h2>
                <ul>
                    <li>Personal Information: We may collect personal information that you provide to us.</li>
                    <li>Usage Data: We may collect information about how you access and use the website.</li>
                </ul>

                <h2>How We Use Your Information</h2>
                <p>We use the information we collect in various ways, including to:</p>
                <ul>
                    <li>Provide, operate, and maintain our website.</li>
                    <li>Improve, personalize, and expand our website.</li>
                    <li>Understand and analyze how you use our website.</li>
                    <li>Communicate with you, either directly or through one of our partners.</li>
                </ul>

                <h2>Sharing Your Information</h2>
                <p>We may share your information in the following situations:</p>
                <ul>
                    <li>With Service Providers: We may share your information with service providers to perform services.</li>
                    <li>For Business Transfers: We may share or transfer your information in connection with a merger, sale, or acquisition.</li>
                </ul>

                <h2>Your Rights</h2>
                <p>Depending on your location, you may have the following rights regarding your personal information:</p>
                <ul>
                    <li>The right to access your personal information.</li>
                    <li>The right to request correction of your personal information.</li>
                    <li>The right to request deletion of your personal information.</li>
                </ul>

                <h2>Changes to This Privacy Policy</h2>
                <p>We may update our Privacy Policy from time to time. We will notify you of any changes 
                    by posting the new Privacy Policy on this page.
                </p>

                <h2>Contact Us</h2>
                <p>If you have any questions about this Privacy Policy, please contact us:</p>
                <p>Email: leveragexfund@gmail.com</p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
